import { TAsyncThunkAction } from 'shared/types/redux';
import { selectJsonQuery } from 'shared/selectors/jsonQuery';
import type { ITagOption } from '@cian/ui-kit';
import { modifyJsonQueryByRemovingTag, parseTagValue } from '../../../packages/Tags';
import { setJsonQuery } from 'shared/slices/jsonQuery';
import { updateSearchMeta } from '../searchMeta';
import { selectTags } from 'shared/selectors/tags';
import { setTags } from 'shared/slices/tags';
import { updateLastAppliedFilter } from 'shared/slices/searchMetaTooltip';
import { getTermsValue } from '../../../packages/JsonQuery';
import { selectLocation } from 'shared/selectors/location';
import { ILocation } from 'shared/types/location';
import { setRegionId } from '../../../packages/JsonQuery/setRegionId';
import { setLocation } from 'shared/slices/location';
import { LOCATION_BY_ID } from 'shared/constants/regions';
import { updateCity } from 'shared/slices/geo';
import { applyFilters } from '../filters';
import { trackRemoveTag } from '../../utils/analytics';
import { selectQuerystring, selectSearchMetaData } from 'shared/selectors/searchMeta';
import { getRemovedQueryParams } from 'shared/utils/string';

export const removeTag =
  (tag: ITagOption): TAsyncThunkAction =>
  async (dispatch, getState, { custom: { applyFilterAfterChange } }) => {
    const state = getState();

    const searchMeta = selectSearchMetaData(state);

    if (!searchMeta) {
      await dispatch(updateSearchMeta());
    }

    const jsonQuery = selectJsonQuery(getState());
    const tags = selectTags(getState());

    const [tagId, tagValue] = parseTagValue(tag.value);

    let nextJsonQuery = modifyJsonQueryByRemovingTag({ jsonQuery, removingTagValue: tag.value });

    const regionId = getTermsValue('region')(jsonQuery)?.[0];
    /**
     * @description
     * Обрабатываем кейс, когда очищаем город внутри крупного города.
     * Например, Троицк в Москве.
     * Такой город имеет один и тот же id в region и в geo -> location.
     * При удалении такого тега проставляем регион родительского города.
     */
    if (tagId === 'geoLocation' && Number(tagValue) === regionId) {
      const parentId = (selectLocation(state) as ILocation).parentId as number;

      nextJsonQuery = setRegionId(nextJsonQuery)([parentId]);

      const nextLocation = LOCATION_BY_ID[parentId];

      dispatch(setLocation(nextLocation));
      dispatch(updateCity(nextLocation));
    }

    const nextTags = tags.filter(({ value }) => value !== tag.value);
    const tagFilter = tagId.includes('geo') ? 'geo' : 'advancedFilters';

    dispatch(setJsonQuery(nextJsonQuery));
    dispatch(setTags(nextTags));
    dispatch(updateLastAppliedFilter(tagFilter));

    const oldQueryString = selectQuerystring(getState());

    await dispatch(updateSearchMeta());

    const newQueryString = selectQuerystring(getState());

    const removedQueryString = getRemovedQueryParams(oldQueryString, newQueryString);

    trackRemoveTag(removedQueryString);

    if (applyFilterAfterChange) {
      dispatch(applyFilters());

      return;
    }
  };
